import React from 'react';
import Friend from './components/FriendPanel/Friend';
import './App.css'

const App = () => {
  return (
    <div>
      <header>
        <h1>Friends Donation App</h1>
      </header>
      <Friend></Friend>
    </div>
  );
};

export default App;